
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'


const HOST = `${config.API_HOST}`
/* ['generics.ListAPIView'] */
/* params:  */
/* data:  */
const ImportEmployeePatientCoverageList : 
{
  create:   ({params, data, apiToken, extra}:
             { 
                params?: any,
                data?: {[key: string]: any},
                apiToken?: any,
                extra?: any
            }) => any,
} = 
{
  create: async ({params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers["device"] = extra.device;

    const formData = new FormData();
    for (const [key, value] of Object.entries(data) as any) {
      formData.append(key, value)
    }

    const result = await to(base.client.post(`${HOST}/apis/CLM/import-employee-patient-coverage/`,
      formData,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default ImportEmployeePatientCoverageList

